/**
 * TCG Tavern – Gratis-Booster Goal Bar + Auto-Gift Sync (stable)
 * - No infinite refresh loops
 * - Gift sync NOT triggered by MutationObserver
 * - UI updates are safe (suppress observer self-triggers)
 * - Gift is added/removed based on TCG subtotal goal
 * - Gift quantity forced to 1, marked via line-item property _auto_gift="true"
 *
 * Replace your old script completely with this one.
 */
(function () {
  var GOAL_CENTS = 15000; // 150,00 €
  var TCG_TYPE_PREFIX = "TCG";      // product_type starts with "TCG"
  var GIFT_PRODUCT_TYPE = "TCG_GIFT"; // optional fallback product_type
  var GIFT_VARIANT_ID = 16042733764953;

  var busy = false;
  var uiTimer = null;
  var giftTimer = null;
  var drawerObserver = null;

  // Prevent MutationObserver from reacting to our own UI writes
  var suppressObserver = false;

  function money(cents) {
    try {
      var cur =
        window.Shopify && window.Shopify.currency && window.Shopify.currency.active
          ? window.Shopify.currency.active
          : "EUR";
      return (cents / 100).toLocaleString(undefined, { style: "currency", currency: cur });
    } catch (e) {
      return (cents / 100).toFixed(2) + " €";
    }
  }

  function els() {
    return {
      wrap: document.getElementById("tcg-goal"),
      text: document.getElementById("tcg-goal-text"),
      bar: document.getElementById("tcg-goal-bar")
    };
  }

  function applyBar(pct) {
    var e = els();
    if (!e.bar) return;

    var apply = function () {
      var e2 = els();
      if (!e2.bar) return;
      e2.bar.style.setProperty("width", pct + "%", "important");
      e2.bar.style.setProperty("background", "#31b2c9", "important");
      e2.bar.style.setProperty("height", "10px", "important");
      e2.bar.style.setProperty("min-width", pct > 0 ? "2px" : "0px", "important");
    };

    apply();
    requestAnimationFrame(apply);
    setTimeout(apply, 120);
  }

  function isTcgItem(item) {
    var t = (item.product_type || "").trim().toUpperCase();
    return t.indexOf(TCG_TYPE_PREFIX.toUpperCase()) === 0;
  }

  function calcTcgSubtotalCents(cart) {
    var sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (isTcgItem(item)) sum += item.final_line_price;
    }
    return sum;
  }

  function findGiftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id === GIFT_VARIANT_ID) return it;
      if ((it.product_type || "").trim() === GIFT_PRODUCT_TYPE) return it;
      if (it.properties && it.properties._auto_gift === "true") return it;
    }
    return null;
  }

  function renderUIFromCart(cart) {
    var e = els();
    if (!e.wrap || !e.text || !e.bar) return;

    var tcgCents = calcTcgSubtotalCents(cart);

    // Avoid observer loops caused by our own DOM writes
    suppressObserver = true;

    try {
      if (tcgCents <= 0) {
        e.wrap.style.opacity = "0";
        e.wrap.style.pointerEvents = "none";
        e.text.textContent = "";
        e.bar.style.setProperty("width", "0%", "important");
        return;
      }

      e.wrap.style.opacity = "1";
      e.wrap.style.pointerEvents = "auto";

      var pct = Math.max(0, Math.min(100, (tcgCents / GOAL_CENTS) * 100));
      applyBar(pct);

      if (tcgCents >= GOAL_CENTS) {
        e.text.textContent = "Gratis Booster freigeschaltet! 🎁";
      } else {
        e.text.textContent = "Noch " + money(GOAL_CENTS - tcgCents) + " bis zum Gratis Booster 🎁";
      }
    } finally {
      // release suppression after current tick
      setTimeout(function () {
        suppressObserver = false;
      }, 0);
    }
  }

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }

  function addGift() {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1, properties: { _auto_gift: "true" } })
    });
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  // UI updates: can be called more frequently (debounced)
  function scheduleUIUpdate(delay) {
    clearTimeout(uiTimer);
    uiTimer = setTimeout(function () {
      getCart().then(renderUIFromCart).catch(function () {});
    }, delay);
  }

  // Gift sync: run less often, and NEVER from MutationObserver
  function scheduleGiftSync(delay) {
    clearTimeout(giftTimer);
    giftTimer = setTimeout(syncGift, delay);
  }

  function syncGift() {
    if (busy) return;
    busy = true;

    getCart()
      .then(function (cart) {
        // Render UI first (non-blocking)
        renderUIFromCart(cart);

        var tcgCents = calcTcgSubtotalCents(cart);
        var gift = findGiftLine(cart);

        // Below goal: remove gift if present
        if (tcgCents < GOAL_CENTS) {
          if (gift) return changeLine(gift.key, 0);
          return null;
        }

        // Reached goal: ensure gift exists and qty=1
        if (!gift) return addGift();
        if (gift.quantity !== 1) return changeLine(gift.key, 1);

        return null;
      })
      .catch(function () {})
      .finally(function () {
        busy = false;
      });
  }

  function observeDrawer() {
    var drawerRoot = document.querySelector("cart-drawer, .cart-drawer");
    if (!drawerRoot) return;

    if (drawerObserver) drawerObserver.disconnect();

    drawerObserver = new MutationObserver(function () {
      if (suppressObserver) return;

      // Drawer rerendered -> UI might be gone. Update UI only.
      scheduleUIUpdate(120);

      // IMPORTANT: Do NOT gift-sync here to avoid loops/race conditions.
      // Gift sync is triggered by cart events / user actions below.
    });

    drawerObserver.observe(drawerRoot, { childList: true, subtree: true });
  }

  function isCartActionTarget(el) {
    if (!el) return false;

    // Match common cart drawer buttons (plus/minus/remove)
    return (
      el.matches(".quantity__button, [data-quantity-plus], [data-quantity-minus], [data-cart-remove], .cart-remove-button") ||
      (el.getAttribute && el.getAttribute("href") && (el.getAttribute("href").indexOf("/cart/change") >= 0 || el.getAttribute("href").indexOf("/cart/update") >= 0))
    );
  }

  document.addEventListener("DOMContentLoaded", function () {
    observeDrawer();

    // Initial UI + delayed gift sync (let theme init first)
    scheduleUIUpdate(0);
    scheduleGiftSync(900);

    // Drawer may mount late
    setTimeout(observeDrawer, 800);
  });

  // Trigger checks after real cart interactions (not every click)
  document.addEventListener("click", function (e) {
    var drawer = e.target && e.target.closest ? e.target.closest("cart-drawer, .cart-drawer") : null;
    if (!drawer) return;

    var btn = e.target && e.target.closest ? e.target.closest("button, a") : null;
    if (!btn) return;

    if (!isCartActionTarget(btn)) return;

    // Theme will rerender; update UI soon, gift sync after it settles
    scheduleUIUpdate(180);
    scheduleGiftSync(850);
  });

  // Quantity inputs on some themes trigger 'change' events instead of click
  document.addEventListener("change", function (e) {
    var drawer = e.target && e.target.closest ? e.target.closest("cart-drawer, .cart-drawer") : null;
    if (!drawer) return;

    var t = e.target;
    if (!t) return;

    if (t.matches('input[name="updates[]"], input[name="quantity"], .quantity__input, [data-quantity-input]')) {
      scheduleUIUpdate(180);
      scheduleGiftSync(850);
    }
  });

  // Theme / app cart events (if present)
  document.addEventListener("cart:refresh", function () {
    scheduleUIUpdate(180);
    scheduleGiftSync(850);
  });
  document.addEventListener("cart:updated", function () {
    scheduleUIUpdate(180);
    scheduleGiftSync(850);
  });
})();